// **********************************************************
// Package Offer Info Counter
// **********************************************************

const handler = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting && entry.intersectionRatio > 0) {
      const { target } = entry;
      const counterValue = target.getAttribute('data-counter');
      const { separator, decimal } = target.dataset;
      const decimalValue = (counterValue.split('.')[1] || '').toString();
      const decimalPlaces = decimalValue.length;

      const scrollSpyOnce = true;
      new countUp.CountUp(target, counterValue, { separator, decimal, decimalPlaces }, scrollSpyOnce).start();

      observerDataModule.unobserve(target);
    }
  });
};

const observerDataModule = new IntersectionObserver(handler);

document.querySelectorAll('[data-counter]').forEach((element) => observerDataModule.observe(element));
